import type { ReactNode } from 'react';
import type { AxiosError } from 'axios';
import { AsyncJobError } from '../services/asyncJobApi';

/**
 * エラーがストレージ容量超過エラーかどうかを判定する
 */
export function isStorageQuotaError(error: unknown): boolean {
  // AsyncJobError (非同期ジョブポーリング経由)
  if (error instanceof AsyncJobError && error.error_code === 'STORAGE_QUOTA_EXCEEDED') {
    return true;
  }

  // Axios エラー (直接API呼び出し経由)
  const axiosErr = error as AxiosError<{ error_code?: string }>;
  if (axiosErr?.response?.data?.error_code === 'STORAGE_QUOTA_EXCEEDED') {
    return true;
  }

  // pollScenarioJob で付与された error_code
  const anyErr = error as any;
  if (anyErr?.response?.data?.error_code === 'STORAGE_QUOTA_EXCEEDED') {
    return true;
  }

  return false;
}

/**
 * ストレージ容量超過時のトーストメッセージを返す
 */
export function storageQuotaErrorMessage(): ReactNode {
  return (
    <span>
      ストレージ容量の上限に達しました。
      <a href="/trash">ごみ箱</a>を空にすると空き容量を確保できます。
      プランのアップグレードで容量を引き上げることも可能です。
      <a href="/subscription">プランを確認</a>
    </span>
  );
}
